import { z } from "zod";
/**
 * `GET /me/pending` — the four things the person has waiting, in ONE read
 * (T38, plan D39, D33). The Today cards and the nav badges read this.
 *
 * Each signal is the server's own definition, never the client's guess:
 * - `checkIn`: the most recent ended session whose soreness check-in is not
 *   answered, inside the insight's check-in window (48 h after the end) —
 *   the same rule as the `pain_checkin` insight, so the card and the badge
 *   agree. Answering it is `PUT /me/sessions/:id/soreness`.
 * - `trainerUnread`: the newest own conversation with a trainer answer after
 *   the person last looked (`PUT /me/conversations/:id/seen`).
 * - `retrospectiveReady`: the last complete ISO week's Retrospectiva is
 *   ready. Nothing stores "opened": the week stays here until it rolls over,
 *   and the client dismisses it locally.
 * - `draft`: the draft `GET /me/plan?draft=1` shows; `null` after a discard.
 *
 * A `z.object`, not a strict one, so a later signal can join it.
 */
export const pendingOutput = z.object({
    checkIn: z
        .object({ sessionId: z.string().min(1), endedAt: z.iso.datetime() })
        .nullable(),
    trainerUnread: z
        .object({
        conversationId: z.string().min(1),
        lastActivityAt: z.iso.datetime(),
    })
        .nullable(),
    retrospectiveReady: z.object({ week: z.string() }).nullable(),
    draft: z
        .object({ planId: z.string().min(1), createdAt: z.iso.datetime() })
        .nullable(),
});
//# sourceMappingURL=pending.js.map